import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { codeToFlag } from "@/features/regions/utils/code-to-flag";
import { Form } from "@/pages/forms/types/form";

type BundleItem = NonNullable<Form["bundles"]>[number];

// Shows the form's linked bundles as active offerings (like the bundles page).
export default function FormBundlesCard({ bundles }: { bundles: BundleItem[] }) {
  const active = bundles.filter(
    (b) => (b.status ?? "").toUpperCase() === "ACTIVE",
  );

  return (
    <Card className="h-full">
      <CardHeader className="pb-3">
        <CardTitle className="text-base">
          Active offerings ({active.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        {active.length === 0 ? (
          <p className="text-sm text-gray-400">No active linked bundles</p>
        ) : (
          <ul>
            {active.map((b) => (
              <li
                key={b.id}
                className="flex items-center justify-between gap-2 text-sm border-b border-gray-100 last:border-0 py-2"
              >
                <span className="flex items-center gap-2 min-w-0">
                  <span>{codeToFlag(b.region_rel?.code)}</span>
                  <span className="min-w-0">
                    <span className="block truncate">{b.name}</span>
                    <span className="block truncate text-[11px] font-mono text-gray-400">
                      {b.standard_id}
                    </span>
                  </span>
                </span>
                <span className="font-medium whitespace-nowrap">
                  {b.currency} {b.amount?.toLocaleString()}
                </span>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
